"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetSensorRollupByTypeDays = void 0;
const react_1 = require("react");
const useGetSensorRollupByDays_1 = require("./useGetSensorRollupByDays");
const useGetSensorRollupByTypeDays = (sensorType, days = 7, dataProvider, rollupInSeconds) => {
    const { sensors, selectedHubId, sensorsLoading } = dataProvider;
    const sensorTypes = Array.isArray(sensorType) ? sensorType : [sensorType];
    const matchedSensor = (0, react_1.useMemo)(() => sensors.find((sensor) => sensor.hubId === selectedHubId && sensorTypes.includes(sensor.type)), [sensors, selectedHubId, sensorType]);
    const { historicalData, loading, error } = (0, useGetSensorRollupByDays_1.useGetSensorRollupByDays)(matchedSensor?.id, days, rollupInSeconds);
    return { sensor: matchedSensor, historicalData, inProgress: sensorsLoading || loading, error };
};
exports.useGetSensorRollupByTypeDays = useGetSensorRollupByTypeDays;
